"use client";

import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface KpiCardProps {
  title: string;
  value: string | number;
  change?: string;
  changeType?: "positive" | "negative" | "neutral";
  icon: LucideIcon;
  iconVariant?: "primary" | "secondary" | "warning" | "success";
  className?: string;
}

export function KpiCard({
  title,
  value,
  change,
  changeType = "neutral",
  icon: Icon,
  iconVariant = "primary",
  className,
}: KpiCardProps) {
  const iconVariants = {
    primary: "kpi-icon-primary",
    secondary: "kpi-icon-secondary",
    warning: "kpi-icon-warning",
    success: "kpi-icon-success",
  };

  const changeColors = {
    positive: "text-success-600",
    negative: "text-error-600",
    neutral: "text-slate-500",
  };

  return (
    <div className={cn("card p-6 group animate-fade-in", className)}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-bold text-slate-600 uppercase tracking-wide">
            {title}
          </p>
          <p className="mt-3 text-4xl font-bold text-slate-900 transition-all duration-300">
            {value}
          </p>
          {change && (
            <p className={cn("mt-2 text-sm font-semibold", changeColors[changeType])}>
              {change}
            </p>
          )}
        </div>
        <div className={cn(iconVariants[iconVariant])}>
          <Icon className="h-7 w-7" />
        </div>
      </div>
    </div>
  );
}
